import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';


@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class CopyLayersMessage extends Component {

  @observable trans = { };

  @observable active = false;


  constructor(props) {

    super(props);

    this.trans = this.props.dictionaryStorage.getCurrentLangDict;

    let scope = this;

    $(window).on('SingleProject-CopyLayersMessage-show',()=>{
      this.active = true;
    })
  }

  @action clickNo = (e) => {
    this.active = false;
    $(window).trigger('CopyLayersMessage-SingleProject-copy-no');
  }

  @action clickYes = (e) => {
    this.active = false;
    $(window).trigger('CopyLayersMessage-SingleProject-copy-yes');
    $(window).trigger('ShowLoader','c1');
  }

  render() {

    const t = this.t;

    return (
      <div className={ this.active ? 'CopyLayersMessage active' : 'CopyLayersMessage' }>
        <div className="CopyLayersMessage-container">
          <h6 className="CopyLayersMessage-title">{t('Copy from existing Elements?')}</h6>
          <div className="CopyLayersMessage-text">{t('Do You want to use all elements from previous page also on this page?')}</div>
          <div className="CopyLayersMessage-buttons">
            <button className="CopyLayersMessage-buttons-no" onClick={this.clickNo}>{t('No')}</button>
            <button className="CopyLayersMessage-buttons-yes" onClick={this.clickYes}>{t('Yes')}</button>
          </div>
        </div>
      </div>
    );
  }
}



